import React from "react";
import PropTypes from "prop-types";

import "./FeedCreationStepper.css";

// TODO: Replace this with the Stepper component from Rhombus 3 once Hopi is upgraded to use Rhombus 3.
export default function FeedCreationStepper({ stepNames, currentStep = 0 }){
	let steps = stepNames.map((name, index) => {
		let isActive = (index === currentStep);
		let isDone = (index < currentStep);

		return (
			<li
				key = {name}
				className = {`feed-creation-step ${isActive ? "active" : ""} ${isDone ? "done" : ""}`}
				aria-current = {isActive ? "step" : undefined}
			>
				<span className="feed-creation-step-circle">
					{isDone ? <i className="fas fa-check" /> : index + 1}
				</span>
				<span className="feed-creation-step-title">{name}</span>
			</li>
		);
	});

	return <ol className="feed-creation-stepper">{steps}</ol>;
}

FeedCreationStepper.displayName = "FeedCreationStepper";
FeedCreationStepper.propTypes = {
	stepNames: PropTypes.arrayOf(PropTypes.string).isRequired,
	currentStep: PropTypes.number,
};
